/**
 * Full-height vertical dividers between the shared compare columns. Render
 * inside a `relative` container that spans the column axis.
 */
export const ColumnDividers = ({ count }: { count: number }) => (
  <>
    {Array.from({ length: count - 1 }).map((_, i) => (
      <div
        key={i}
        className="pointer-events-none absolute inset-y-0 w-px bg-[#2e2e2e]"
        style={{ left: `${((i + 1) / count) * 100}%` }}
      />
    ))}
  </>
);
